import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { API_URL } from '../../global/components/Constants';
import { getUserOrgs } from '../../utils/api-services/global';

function OrgSelectControl({updateOrg}) {

    const [organizaions, setOrganizaions] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState("");
    const [name, setName] = useState("");
    const [about, setAbout] = useState("");
    const [posting, setPosting] = useState(false);
    const [modal, setModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const session = localStorage.getItem("session");

    useEffect(()=>{
        loadOrganizations();
    }, []);

    const loadOrganizations = async () => {
        const data = await getUserOrgs();
        setOrganizaions(data);
    }

    const showModal = ()=>{
        setModal(true);
    }

    const closeModal = ()=>{
        setModal(false);
    }

    function updateSelectedOrg(val){
        setSelectedOrg(val);
        updateOrg(val);
    }

    const saveForm = async ()=>{

        setErrorMsg("");

        if(name == ""){
            setErrorMsg("Please enter organization name");
            return;
        }

        if(about == ""){
            setErrorMsg("Please enter about organization");
            return;
        }
    
        setPosting(true);
    
        const formData = new FormData();
        formData.append('name', name);
        formData.append('about', about);

        axios({
            method: "post",
            url: API_URL + "organization/save_organization",
            data: formData,
            headers: { Authorization: `Bearer ${session}`, "Content-Type": "multipart/form-data" },
            processData: false,
            contentType: false,
            mimeType: "multipart/form-data",
            withCredentials: true
        })
        .then(function (response) {
            const obj = response.data;
            if(obj.Success){
                const result = obj.Data;
                if(result.Slug != ""){
                    const cloneData = [...organizaions];
                    cloneData.push({Slug: result.Slug, Name: name, About: about});
                    setOrganizaions(cloneData);
                    updateSelectedOrg(result.Slug);
                    closeModal();
                }
            }else{
                setErrorMsg(obj.Message);
                setPosting(false);
            }
        })
        .catch(function (response) {
            console.log(response);
          setErrorMsg("Posting Error!");
          setPosting(false);
        });
    }


    const styles = {
        label:{
            color: "#aaa",
            fontSize: 14,
            fontWeight: 500
        },
        errorMsg: {
            color: '#990000',
            fontSize: 16,
        },
    }

    return (
        <div>

            <div class="input-group mb-3">
                <select value={selectedOrg} onChange={e => updateSelectedOrg(e.target.value)} class="form-control" placeholder="Some text">
                    <option value="">- Select Organization -</option>
                    {organizaions.map(itm => (
                        <option value={itm.Slug}>{itm.Name}</option>
                    ))}
                </select>
                <div class="input-group-prepend">
                    <button onClick={showModal} class="btn btn-outline-primary" type="button">New</button>
                </div>
            </div>

            <Modal show={modal} onHide={closeModal} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title style={{fontSize:15}}>Organization</Modal.Title>
                    <button type="button" onClick={closeModal} className="close">&times;</button>
                </Modal.Header>
                <Modal.Body> 

                    <div className="form-group">
                        <label style={styles.label}>Name</label>
                        <input type="text" value={name} onChange={e => setName(e.target.value)} className="form-control" placeholder="Enter organization name" />
                    </div>

                    <div className="form-group">
                        <label style={styles.label}>About</label>
                        <textarea value={about} onChange={e => setAbout(e.target.value)} className="form-control" placeholder="About organization"></textarea>
                    </div>

                    {errorMsg != "" && 
                        <div style={styles.errorMsg} className="form-group">{errorMsg}</div>
                    }

                    <div className="form-group">
                        <button onClick={saveForm} className='btn btn-primary'>Save</button>
                    </div>

                </Modal.Body> 
            </Modal>
        </div>
    )
}

export default OrgSelectControl;